
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useState } from "react";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";
import { SkipNavigation } from "@/components/ui/SkipNavigation";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <>
      <SkipNavigation />
      <div className="flex h-screen bg-gradient-to-br from-gray-50 to-slate-100 overflow-hidden">
      <ErrorBoundary>
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggleCollapse={setSidebarCollapsed}
        />
      </ErrorBoundary>
      <div className="flex flex-1 flex-col min-w-0">
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        <main id="main-content" className="flex-1 overflow-auto p-4 sm:p-6 md:p-8 relative z-0">
          <div className="mx-auto max-w-7xl">
            {children}
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
